<template>
  <div class="row mt-6">
    <div class="col-md-12">
      <div class="card">
        <div class="card-header">
          <h5>
            <i class="fe fe-file"></i>
            <strong>{{ documents.length }} Documents </strong>
          </h5>
        </div>

        <div class="table-responsive">
          <table class="table align-td-middle card-body">
            <thead>
              <tr>
                <th>S/N</th>
                <th>Name</th>
                <th>Date Created</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(doc, index) in documents" v-bind:key="doc.id">
                <td>{{ index + 1 }}</td>
                <td>{{ doc.name }}</td>
                <td>
                  {{ doc.created_at | moment("dddd, MMMM Do YYYY") }}
                </td>
                <td>
                  <a :href="`
                      ${doc.image_url}
                    `" target="_blank">
                    <button class="btn btn-outline-info" name="button">
                      <i class="fe fe-eye"></i>
                    </button>
                  </a>

                  <button class="btn btn-outline-danger mx-2" name="button" @click="deleteDocument(doc)">
                    <i class="fe fe-delete"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: ["documents"],
    data() {
      return {
        //   documents: "",



        deleteDocument(doc) {
          if (confirm("Are you Sure you want to delete this document?")) {
            this.axios
              .delete(`/api/v1/auth/documents/${doc.id}`)
              .then((response) => {
                console.log(response);

                this.$toasted.success("Deleted Successfully", {
                  position: "top-center",
                  duration: 3000,
                });
              })
              .catch((error) => {
                console.error(error);
              });
          }
        },
      };
    },

    methods: {
      getChart(param) {
        this.isLoading = true;
        this.sector = param;
        this.getDashboardLGA();
        this.isLoading = false;
      },
    },
  };
</script>